import React from "react";
import { BrandDocumentTitle } from "./shared/branding";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider, MutationCache } from "@tanstack/react-query";
import { AuthProvider } from "@/providers/AuthProvider";
import { RealtimeBridge } from "@/realtime/useRealtime";
import App from "./App";
import "./index.css";
// ═ COMPANY-STRIP BEGIN ═ COMPANY-CUT-1 · 主题层（THEME-1）：公司版固定经典蓝（index.css 里的默认变量），没有预设 / 切换
import { bootTheme } from "@/theme/applyTheme";
import { ThemeSync } from "@/theme/useTheme";
// ═ COMPANY-STRIP END ═

// THEME-1 · 渲染前按上次缓存的主题令牌换好色（classic 且没改色 = 什么都不写）
// ═ COMPANY-STRIP BEGIN ═
bootTheme();
// ═ COMPANY-STRIP END ═

// C1 护栏：低频主数据列表 staleTime 调到 5min（lib/queryConfig）·若不在写后失效→
// 「建完主数据回列表 5min 看不到新建的」。这里全局兜底：任何 mutation 成功→失效这 6 类
// 主数据 query（前缀匹配 list+detail）·确保写后列表恒新（比原 30s 陈旧更安全）。
const MASTER_KEYS = ["products", "hotels", "drivers", "vehicles", "attractions", "suppliers"];

const queryClient = new QueryClient({
  mutationCache: new MutationCache({
    onSuccess: () => {
      MASTER_KEYS.forEach((k) => queryClient.invalidateQueries({ queryKey: [k] }));
    },
  }),
  defaultOptions: {
    queries: { staleTime: 30_000, refetchOnWindowFocus: false, retry: 1 },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RealtimeBridge />
      <BrandDocumentTitle />
      {/* ═ COMPANY-STRIP BEGIN ═ */}
      <ThemeSync />
      {/* ═ COMPANY-STRIP END ═ */}
      <AuthProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
